import type { UrlSyncConfig } from "@/shared/contexts/FiltersContextFactory";
import type { SupplierFiltersState } from "../contexts/SupplierFiltersContext";

export const supplierUrlSync: UrlSyncConfig<SupplierFiltersState> = {
  urlKeys: ["search"],
  storageKey: "suppliers-filters-v1",
  parse: (params) => ({ search: params.get("search") ?? "" }),
  serialize: (state) => {
    const params = new URLSearchParams();
    if (state.search) params.set("search", state.search);
    return params;
  },
};
